import _ from 'lodash';
import { deliveryPeriodStatuses } from '../constants';
import { getEanForColorAndSize, getProductsByNumber } from './products';
import { mapDeliveryPeriods } from '../utils/products';

import { isPast } from '../utils/date';
import { getCurrentOrder } from './orders';

export const getProductDeliveryPeriods = (context) => _.get(context, 'entities.productDeliveryPeriods');

export const getDeliveryPeriodsForEan = ({ context, ean }) => {
  const productDeliveryPeriods = getProductDeliveryPeriods(context);

  const deliveryPeriodForEan = productDeliveryPeriods[Number(ean)];
  if (!deliveryPeriodForEan) return null;

  return deliveryPeriodForEan;
};

export const getDeliveryPeriods = (context) => _.get(context, 'entities.deliveryPeriods');

export const getDeliveryPeriodForEan = ({
  context,
  number,
  color,
  size,
  deliveryPeriodId,
}) => {
  const ean = getEanForColorAndSize({
    number, context, color, size,
  });
  const periods = getDeliveryPeriodsForEan({ context, ean });
  const period = _.get(periods, deliveryPeriodId);

  return period;
};

export const isAvailableForDelivery = (periods, deliveryPeriodId) => {
  const period = _.get(periods, deliveryPeriodId);
  return (
    period === deliveryPeriodStatuses.AVAILABLE
    || period === deliveryPeriodStatuses.CLOSED_BUT_ORDER_AVAILABLE
  );
};

export const getDeliveryPeriodForProduct = (context) => ({ productNumber }) => {
  const productDeliveryPeriods = getProductDeliveryPeriods(context);
  const deliveryPeriods = getDeliveryPeriods(context);

  const eans = getProductsByNumber(context);
  if (!eans) return null;

  const eansForNumber = eans[productNumber];

  if (!eansForNumber) return null;

  return _.compact(
    _.flatten(
      Object.keys(eansForNumber).map((ean) => {
        if (ean) {
          const deliveryPeriodForEan = productDeliveryPeriods[ean];
          if (deliveryPeriodForEan && deliveryPeriods) {
            const periods = Object.keys(deliveryPeriodForEan);
            return periods.map((p) => {
              const dates = deliveryPeriods[p];
              if (dates) {
                return {
                  id: p,
                  start: dates.s,
                  end: dates.e,
                };
              }
              return null;
            });
          }
        }
        return null;
      }),
    ),
  );
};

const filterPastPeriods = (periods) => _.filter(periods, (p) => !isPast(p.s));

export const getDeliveryOptions = (context) => _.get(context, 'entities.deliveryOptions');

export const getAvailableDeliveryPeriods = (context) => {
  if (!context) return null;

  return _.values(filterPastPeriods(getDeliveryPeriods(context)));
};

export const getDeliveryDataForProduct = (context, productNumber) => {
  const deliveryPeriods = getDeliveryPeriodForProduct(context)({
    productNumber,
  });

  const deliveryPeriodsMapped = mapDeliveryPeriods(deliveryPeriods);

  const currentOrder = getCurrentOrder(context);

  const defaultDeliveryDate = currentOrder
    ? currentOrder.doc.defaultDeliveryDate
    : null;

  const includesDeliveryPeriod = defaultDeliveryDate
    && _.map(deliveryPeriodsMapped, 'value').includes(defaultDeliveryDate.value);

  return { includesDeliveryPeriod, defaultDeliveryDate, deliveryPeriodsMapped };
};
